export default "__VITE_ASSET__c4e81b7d__"